import React from 'react'
import ReactApexChart from 'react-apexcharts'

class SplineChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            series: [{
                name: [this.props.name],
                data: this.props.data
            }],
            options: {
                chart: {
                    height: 350,
                    type: 'area'
                },
                dataLabels: {
                    enabled: false
                },
                colors: [this.props.color],
                stroke: {
                    curve: 'smooth'
                },
                xaxis: {
                    categories: this.props.dates,
                },
                tooltip: {
                    x: {
                        format: 'dd/MM/yy HH:mm'
                    },
                },
            },
        };
    }

    render() {
        return (
            <div id="chart">
                <ReactApexChart
                    options={this.state.options}
                    series={this.state.series}
                    type="area"
                    height={350} />
            </div>
        )
    }
}

export default SplineChart